import { Link, Text } from '@chakra-ui/react';
import { Color } from 'presentation/theme/colorScheme';
import { FontSize } from 'presentation/theme/fontSizes';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

const AuthWarningText: FC = () => {
  const { t, i18n } = useTranslation();

  const handlePrivacyPolicyClick = (): void => {
    window.open('https://docs.sharespro.ru/privacy_policy.pdf', '_blank');
  };

  const handleTermsOfServiceClick = (): void => {
    window.open('https://docs.sharespro.ru/terms_of_service.pdf', '_blank');
  };

  const warningText = t('authWarningText');
  const privacyLink = t('privacyPolicyLink');
  const termsLink = t('termsOfServiceLink');

  const privacyPattern = i18n.language === 'ru' ? 'обработку персональных данных' : 'processing of personal data';
  const termsPattern = i18n.language === 'ru' ? 'пользовательского соглашения' : 'user agreement';

  const parts = warningText.split(new RegExp(`(${privacyPattern}|${termsPattern})`));

  return (
    <Text textAlign="center" fontSize={FontSize.sm} maxW="720px" color={Color.Shade500}>
      {parts.map((part, index) => {
        if (part === privacyPattern) {
          return (
            <Link
              key={index}
              color={Color.Primary500}
              textDecoration="underline"
              onClick={handlePrivacyPolicyClick}
              cursor="pointer"
            >
              {privacyLink}
            </Link>
          );
        } else if (part === termsPattern) {
          return (
            <Link
              key={index}
              color={Color.Primary500}
              textDecoration="underline"
              onClick={handleTermsOfServiceClick}
              cursor="pointer"
            >
              {termsLink}
            </Link>
          );
        }

        return part;
      })}
    </Text>
  );
};

export default AuthWarningText;
